export default { sha: 'aafc923ad08634750636a41d34a2028865e5adfe', buildNumber: 'undefined' }
